import { t } from "@travily/i18n";
import type { ProgramFormat } from "@travily/types/models";
import { FieldSet } from "@ui/components/FieldSet";
import { InfluenceFilters } from "./components/InfluenceFilters";
import { InstructionLanguageFilter } from "./components/InstructionLanguageFilter";
import { ProgramsAvailabilityFilter } from "./components/ProgramsAvailabilityFilter";
import { ProgramsFormatFilter } from "./components/ProgramsFormatFilter";
import { RecommendedFilters } from "./components/RecommendedFilters";
import type { ProgramAvailabilityFilterValue, RecommendedFilterKey } from "./constants";

export interface ProgramsFiltersProps {
  availability: ProgramAvailabilityFilterValue;
  formats: string[];
  influences: string[];
  languages: string[];
  onAvailabilityChange: (value: ProgramAvailabilityFilterValue) => void;
  onFormatToggle: (value: ProgramFormat) => void;
  onInfluenceToggle: (value: string) => void;
  onLanguagesChange: (values: string[]) => void;
  onRecommendedChange: (key: RecommendedFilterKey, value: boolean) => void;
  recommended: Record<RecommendedFilterKey, boolean>;
}

export function ProgramsFilters({
  availability,
  formats,
  influences,
  languages,
  onAvailabilityChange,
  onFormatToggle,
  onInfluenceToggle,
  onLanguagesChange,
  onRecommendedChange,
  recommended,
}: ProgramsFiltersProps) {
  return (
    <FieldSet.List size="lg">
      <FieldSet>
        <FieldSet.Legend>{t("components.views.programs.search.recommended_label")}</FieldSet.Legend>
        <RecommendedFilters onChange={onRecommendedChange} values={recommended} />
      </FieldSet>
      <FieldSet>
        <FieldSet.Legend>{t("components.views.programs.search.availability_label")}</FieldSet.Legend>
        <ProgramsAvailabilityFilter onChange={onAvailabilityChange} value={availability} />
      </FieldSet>
      <FieldSet>
        <FieldSet.Legend>{t("components.views.programs.search.format_label")}</FieldSet.Legend>
        <ProgramsFormatFilter onToggle={onFormatToggle} selected={formats} />
      </FieldSet>
      <FieldSet>
        <FieldSet.Legend>{t("components.views.programs.search.influences_label")}</FieldSet.Legend>
        <InfluenceFilters onToggle={onInfluenceToggle} selected={influences} />
      </FieldSet>
      <FieldSet>
        <FieldSet.Legend>{t("components.views.programs.search.instruction_language_label")}</FieldSet.Legend>
        <InstructionLanguageFilter onChange={onLanguagesChange} selected={languages} />
      </FieldSet>
    </FieldSet.List>
  );
}
